import ContentPost from "content/ContentPost";
import FieldEditor from "editor/FieldEditor";
import GlobalEvents from "base/GlobalEvents";
import ContentCaseStudySnippetTab from "./ContentCaseStudySnippetTab";

class ContentPostCaseStudy extends ContentPost {

    constructor($elm) {
        super($elm);
        this.on('enableInput.title enableInput.introduction-text enableInput.subheading', (data) => {
            let $editor = eotwJSXFactory('div', null, [data.$input.text()]);
            data.$input.html($editor);
            data.editor = FieldEditor.get_editor('wysiwyg', $editor, {noFormatting: true, inline: true});
            return false;
        }).on('startEditing', (e) => {
            GlobalEvents.emit("PageAnimations.clear_all");
        }).on('enabledInputs', (e) => {

            e.editors['gallery'].on("update", function (data) {

                let $gallery = $('.js-gallery');
                $gallery.find('.js-item').remove();

                data.items.forEach((item) => {
                    if (item.data.type.id !== "1"/*Video*/) return;

                    $gallery.append(
                        eotwJSXFactory('div', {class: "masonry-section__item masonry-section__item--video js-item js-video-item", 'data-provider': item.data.provider.id, 'data-video-id': item.data.customData.id}, [
                            eotwJSXFactory('div', {class: "masonry-section__video-thumbnail", style: "background: url(" + item.data.customData.thumbnail + ") center center no-repeat; background-size: cover"}),
                            eotwJSXFactory('div', {class: "masonry-section__video-play"}).html('<svg><use xlink:href="/includes/svg-icons.svg#play-icon"></use></svg>')
                        ])
                    )
                });

                data.items.forEach((item) => {
                    if (item.data.type.id !== "2"/*Image*/) return;

                    let additionalClass = item.data.orientation === 1 /*SQUARE*/ ? '' : (item.data.orientation === 2 /*LANDSCAPE*/ ? 'masonry-section__item--landscape' : 'masonry-section__item--portrait');

                    $gallery.append(
                        eotwJSXFactory('div', {class: "masonry-section__item " + additionalClass + " js-item"}, [
                            eotwJSXFactory('img', {class: "masonry-section__image", 'data-object-fit': "cover", src: item.data.versions["4"/*LARGE*/].url, srcset: item.data.srcset})
                        ])
                    )
                });

                if (typeof window.isotope !== 'undefined') {
                    window.isotope.reloadItems();
                    setTimeout(() => {
                        window.isotope.arrange();
                    });
                }

            });
            $(".js-gallery").show();
        }).on("stopEditing", () => {
            if ($(".js-gallery .js-item").length === 0) {
                $(".js-gallery").hide();
            }
        }).on('openSettings', (modal) => {
            modal.addTab(new ContentCaseStudySnippetTab(this));
        })
    }


    setInputData(data) {
        super.setInputData(data);

        $("title").text(this.workingRevision.values['meta-title']);
        $("meta[name='description']").attr("content", this.workingRevision.values['meta-description']);
    }
}

export default ContentPostCaseStudy;